import { baseServiceInvoiceSchema } from "@redotech/redo-billing-common/service-invoice";
import * as z from "zod/v4";

export const getFinalizedImsInvoices = {
  name: "getFinalizedImsInvoices" as const,
  input: z.null(),
  output: z.array(baseServiceInvoiceSchema),
};
